import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../../../components/CssFrameworkComponents';
import RenderingLocationCard from './renderingLocationCard';
import SaveIndicator from '../../components/SaveIndicator';
import { useAutoSaveSetting } from '../../hooks/useAutoSaveSetting';
import { usePrerenderUser } from '../../../../hooks/usePrerenderUser';

const SHARED = 'shared';
const US = 'us';
const EU = 'eu';

const RENDER_LOCATION_CHANGE_FEATURE = 'render_location_change';

const CM = {
  title: 'Rendering Location',
  current: 'Current',
  select: 'Select',
  upgrade: 'Upgrade Plan',
  descriptions: ['With this option you can set where the render should happen.'],
  shared: { title: 'Global Shared' },
  us: { title: 'United States' },
  eu: { title: 'Europe' },
};

const RenderingLocationsCard = () => {
  const navigate = useNavigate();
  const { settings, features } = usePrerenderUser();
  const { save, status, retry } = useAutoSaveSetting();

  const renderRegion = settings.renderRegion;
  const changeAvailable = features.includes(RENDER_LOCATION_CHANGE_FEATURE);
  const saving = status === 'saving';

  const isOnShared = renderRegion === SHARED;
  const isOnUS = renderRegion === US;
  const isOnEU = renderRegion === EU;

  const sharedButtonText = isOnShared ? CM.current : CM.select;
  const usButtonText = changeAvailable ? (isOnUS ? CM.current : CM.select) : CM.upgrade;
  const euButtonText = changeAvailable ? (isOnEU ? CM.current : CM.select) : CM.upgrade;

  const onSharedSelected = () => {
    save({ renderRegion: SHARED });
  };

  const onUSSelected = () => {
    if (changeAvailable) {
      save({ renderRegion: US });
    } else {
      navigate('/billing/plans');
    }
  };

  const onEUSelected = () => {
    if (changeAvailable) {
      save({ renderRegion: EU });
    } else {
      navigate('/billing/plans');
    }
  };

  return (
    <Card title={CM.title}>
      <div className="col">
        {CM.descriptions.map((description) => (
          <div className="row" key={description}>
            <p>{description}</p>
          </div>
        ))}
        <div className="row">
          <div className="col">
            <RenderingLocationCard
              current={isOnShared}
              icon={'fe-globe'}
              title={CM.shared.title}
              buttonText={sharedButtonText}
              onClick={onSharedSelected}
            />
          </div>
          <div className="col">
            <RenderingLocationCard
              current={isOnUS}
              disabled={saving}
              icon={'fe-map-pin'}
              title={CM.us.title}
              buttonText={usButtonText}
              onClick={onUSSelected}
            />
          </div>
          <div className="col">
            <RenderingLocationCard
              current={isOnEU}
              disabled={saving}
              icon={'fe-map-pin'}
              title={CM.eu.title}
              buttonText={euButtonText}
              onClick={onEUSelected}
            />
          </div>
        </div>
        <div className="row">
          <SaveIndicator status={status} onRetry={retry} />
        </div>
      </div>
    </Card>
  );
};

export default RenderingLocationsCard;
